import { ApiV2 } from '../../commonv2/api/ApiV2';
import { locatePath } from '../../common/RelativeUrl';
import { CourseDetail, CourseId } from '../types/course';
import { LessonId } from '../types/lesson';

export const CourseApis = {
    base() {
        return new ApiV2(locatePath('/api/v2/courses'));
    },
    /**
     * Returns course and some information
     * @returns {Promise<CourseDetail>}
     */
    async getCourse(id: CourseId): Promise<CourseDetail> {
        return await this.base()
            .withId(id)
            .get();
    },
    /**
     * Returns all courses that is active
     * A course is active when the course is public and has at least one active lesson
     * @returns {Promise<CourseDetail[]>}
     */
    async findAllActive(): Promise<CourseDetail[]> {
        return await this.base().get();
    },
    /**
     * Make a reservation to some lessons
     * @param {LessonId[]} lessonIds
     * @returns {Promise<void>}
     */
    async reserve(lessonIds: LessonId[]): Promise<void> {
        return await this.base()
            .appendPath('reserve')
            .post({ lesson_ids: lessonIds });
    },
};

export const CourseEvaluationApis = {
    base(courseId: CourseId) {
        return new ApiV2(locatePath(`/api/v2/courses/${courseId}/course_evaluation`));
    },
    async create(courseId: CourseId, payload: Object): Promise<void> {
        return await this.base(courseId).post(payload);
    },
};
